export const themeConfig = {
  light: {
    // Main backgrounds
    bgPrimary: "bg-white",
    bgSecondary: "bg-gray-50",
    bgTertiary: "bg-[#23262B]",
    bgPrimaryDarker: "bg-[#32363D]",
    bgCard: "bg-gray-800",
    cardBackground: "bg-[#292D33]",
    bgDropFiles: "bg-[#002F4036]",
    bgDropFilesActive: "bg-blue-900/20",
    bgInput: "bg-[#00000033]",
    bgBlurModal: "bg-[#000000]/60",
    bgNoTag: "bg-[#FFFFFF]/80",
    bgActiveToggle: "bg-[#2D8F00]",
    bgModal: "bg-white",
    bgSelectedRow: "bg-[#234455]",
    bgSelectedItem: "bg-[#01BBFE29]",
    bgSelectedOption: "bg-[#01BBFE1A]",
    bgSelectedRadio: "bg-[#01BBFE]",
    bgSelectedCyanSubtle: "bg-cyan-500/10",
    bgImportOverlay: "bg-black/70",
    bgSkeleton: "bg-gray-600",
    bgSkeletonDark: "bg-gray-600",
    bgTableBody: "bg-[#2A2D34]",
    bgTableHeader: "bg-[#292D33]",
    bgTableStripe: "bg-[#23262B]",
    bgRadioInactive: "bg-[#191B1F]",
    bgRadioSelected: "bg-[#333131]",
    bgDisabledControl: "bg-gray-800",
    bgEditedRow: "bg-green-900/20",
    bgMoveDisabled: "bg-gray-400",
    bgDisabledAction: "bg-gray-600",
    buttonMoveGradient: "bg-gradient-to-br from-blue-400 to-blue-600",
    buttonMoveGradientHover: "hover:from-blue-500 hover:to-blue-700",
    bgPaginationButtonActive: "bg-[#3F454D]",
    bgActivePrimary: "bg-[#01BBFE]",
    bgButton: "bg-transparent",
    bgDocumentTable: "bg-[#B0C1D90F]",
    bgFulfillmentStripe: "bg-[#23262B]",
    bgSelectedPreviewName: "bg-[#32363D]",
    bgPolicyConflict: "bg-[#9EA5B3]",
    bgVerifReportFile: "bg-[#23262B]",
    bgBasicInfo: "bg-[#212429]",
    bgDanger: "bg-[#FF5050]",
    bgAddVerificationFileBtn: "bg-[#202d36]",
    bgActiveTab: "bg-[#01BBFE26]",
    bgCommunicationDetail: "bg-[#32363D]",
    bgDivider: "bg-[#414956]",
    bgCompletionRequestDate: "bg-[#FDC1010F]",
    bgCommunicationFilterButtonActive: "bg-[#6C727B]",
    bgCommunicationFilterButton: "bg-[#3E444E]",
    bgStatusHealthy: "bg-green-500",
    bgStatusUnhealthy: "bg-red-500",
    bgStatusUnconfigured: "bg-yellow-500",
    bgStatusUnknown: "bg-gray-500",
    dashboardMetricCard: "bg-gradient-to-b from-[#01BBFE26] to-transparent border-[#01BBFE36]",
    dashboardMetricCardDanger: "bg-gradient-to-b from-[rgba(254,31,1,0.15)] to-transparent border-[#FC3F3F36]",
    dashboardChartRingBg: "bg-[#FFFFFF0D]",
    dashboardLegendPurple: "bg-[#7252FF]",
    dashboardLegendPink: "bg-[#EF7BE3]",
    dashboardLegendLime: "bg-[#CBFB47]",
    dashboardUsageToggleBg: "bg-[#191B1F]",
    dashboardUsageToggleActive: "bg-[#343B43] text-white font-semibold",
    dashboardUsageToggleInactive: "text-gray-400 bg-[#191B1F]",
    dashboardPanelBg: "bg-[#282D32]",
    dashboardProgressTrack: "bg-gray-700",
    dashboardProgressJvm: "bg-blue-500",
    dashboardProgressMemory: "bg-green-500",
    dashboardProgressCpu: "bg-yellow-500",
    dashboardProgressDisk: "bg-purple-500",
    bgDisableButton: "bg-[#CA2C26]",
    bgPolicyStepItemLeftSide: "bg-[#191B1F80]",
    bgPolicyStepItem: "bg-[#23262B]",
    bgPolicyAttributeItemLeftSide: "bg-[#5B6D8C8F]",
    bgPolicyAttributeItemRightSide: "bg-[#7DACC921]",
    bgToggleSwitchActive: "bg-[#2D8F00]",
    bgToggleSwitchInactive: "bg-gray-600",
    toggleThumbBackground: "bg-white",
    bgButtonDanger: "bg-[#CA2C26]",
    bgButtonDangerHover: "hover:bg-red-700",
    bgWarning: "bg-yellow-600",
    bgWarningHover: "hover:bg-yellow-700",
    bgStatusWarning: "bg-[#FF9501]",
    bgStatusSuccess: "bg-[#00B649]",
    bgStatusMuted: "bg-gray-400",
    bgStatusAnalysis: "bg-[#FF4800]",
    bgStatusRequest: "bg-[#CD00D0]",
    bgStatusVerification: "bg-[#FF9501]",
    bgStatusReview: "bg-[#14EFFF]",
    bgStatusFollowup: "bg-[#3999FF]",
    bgStatusReverification: "bg-[#B2DC3F]",
    bgStatusWritingReview: "bg-[#00BDEC]",
    bgStatusTagPending: "bg-orange-900/30",
    bgStatusTagDone: "bg-green-900/30",
    bgStatusTagCompletion: "bg-yellow-900/30",
    bgStatusTagNeutral: "bg-gray-700",
    bgStatusAllowed: "bg-[#00B6491A]",
    bgStatusBlocked: "bg-[#FF50501A]",
    textStatusAllowedBright: "text-[#2FFF83]",
    textDangerSoft: "text-[#FF9A9A]",
    textStatusWritingReview: "text-[#00BDEC]",
    requestStatusPendingCompletion: "text-[#FF8400] bg-[#FF840029]",
    requestStatusPendingApproval: "text-[#68D7FF] bg-[#68D7FF29]",
    requestStatusDone: "text-[#2FFF83] bg-[#00B64929]",
    alertUploadWarning: "border-yellow-700/50 bg-yellow-900/20 text-yellow-200",
    buttonDangerOutlineActive: "bg-transparent border-[#FF5050] text-[#FF5050]",
    hoverBgDangerSoft: "hover:bg-red-500/20",
    bgVulnMatrixPanel: "bg-[#191B1F]",
    bgVulnMatrixCellEmpty: "bg-[#212327]",
    borderVulnMatrix: "border-[#2b2d31]",
    textVulnMatrixLabel: "text-gray-300",
    policyItemChip: "bg-[#414956] text-white",
    matrixCellDisabled: "opacity-50 cursor-not-allowed bg-gray-600 text-gray-400",
    matrixCellActive: "text-white hover:opacity-80",
    hoverTextNeutralStrong: "hover:text-gray-200",
    importStatusIdle: "text-[#9CA3AF] bg-[#9CA3AF29]",
    bgMailTypeExternal: "bg-[#FDC1011A]",
    badgeYes: "bg-[#C3FF61] text-gray-800",
    badgeNo: "bg-gray-500 text-gray-200",
    bgGroupCardActive: "bg-blue-500/30",
    buttonDisabledMuted: "cursor-not-allowed bg-gray-400 text-gray-600 opacity-50",
    badgeRoleChip: "bg-gray-700 text-gray-300",
    bgSbomInfoPanel: "bg-[#2b2f38]",
    textInfoAccent: "text-sky-500",
    hoverTextInfoAccent: "hover:text-sky-400",
    licensePeriodSummaryBorder: "border-[#01BBFE66]",
    licensePeriodSummaryChip: "border border-[#01BBFE80] bg-[#01BBFE26] text-[#01BBFE]",
    licensePeriodCurrentBadge: "bg-[#01BBFE] text-white",
    licensePeriodCurrentAccent: "border-l-2 border-[#01BBFE]",
    licensePeriodRankLow: "border border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
    licensePeriodRankMedium: "border border-orange-500/40 text-orange-400 bg-orange-500/10",
    licensePeriodRankHigh: "border border-red-500/40 text-red-400 bg-red-500/10",
    licensePeriodRankCritical: "border border-rose-500/50 text-rose-300 bg-rose-500/15",
    licensePeriodConfidenceConfirmed: "border border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
    licensePeriodConfidenceLikely: "border border-orange-500/40 text-orange-400 bg-orange-500/10",
    licensePeriodConfidencePossible: "border border-yellow-500/40 text-yellow-400 bg-yellow-500/10",
    licensePeriodConfidenceDefault: "border border-gray-500/40 text-gray-300 bg-gray-500/10",
    textLicensePeriodAccent: "text-[#01BBFE]",
    bgAvatarNeutral: "bg-gray-500",
    bgAvatarBlue: "bg-blue-500",
    bgAvatarGreen: "bg-green-500",
    bgAvatarPurple: "bg-purple-500",
    bgAvatarPink: "bg-pink-500",
    bgAvatarIndigo: "bg-indigo-500",
    bgAvatarYellow: "bg-yellow-500",
    bgAvatarRed: "bg-red-500",
    bgAvatarTeal: "bg-teal-500",
    bgActionPrimary: "bg-blue-500",
    hoverActionPrimary: "hover:bg-blue-600",
    dividerColor: "bg-[#414956]",

    // Buttons
    buttonBackgroundGradient: "bg-gradient-to-r from-[#1EC6FF] to-[#367FFF]",
    buttonBackgroundPurple: "bg-gradient-to-r from-[#C374FF] to-[#C084FF]",
    buttonBackgroundPurpleHover: "hover:bg-gradient-to-l hover:from-[#C374FF] hover:to-[#C084FF]",
    buttonBackgroundGradientHover: "hover:bg-gradient-to-l hover:from-[#1EC6FF] hover:to-[#367FFF]",
    buttonDangerBackground: "bg-[#CA2C26]",
    buttonDangerBackgroundHover: "hover:bg-red-600",
    buttonSuccess: "bg-green-600 text-white hover:bg-green-700",
    alertInfo: "bg-blue-900/20 border-blue-500/30 text-blue-200",
    alertSuccess: "bg-green-900/20 border-green-500/30 text-green-200",
    alertWarning: "bg-amber-500/10 border-amber-500/40",
    alertError: "bg-red-900/20 border-red-500/30 text-red-200",
    alertErrorSoft: "bg-red-500/10 border-red-500/40",
    bgIconAccent: "bg-[#01BBFE33]",
    spinnerBorder: "border-[#414956] border-t-[#01BBFE]",
    // Text colors
    textPrimary: "text-[#FFFFFFE5]",
    textSecondary: "text-[#A6ACBE]",
    textModalMessage: "text-[#A6ACBE]",
    textSubTitle: "text-[#9EA5B3]",
    textActive: "text-[#01BBFE]",
    textHoverActive: "hover:text-[#01BBFE]",
    textMuted: "text-gray-400",
    textPlaceholder: "placeholder-[#646874]",
    textButton: "text-[#000000]",
    hoverTextButton: "hover:text-black",
    textCompletionRequestDate: "text-[#FDC101]",
    textStatusHealthy: "text-green-500",
    textStatusUnhealthy: "text-red-500",
    textStatusUnconfigured: "text-yellow-500",
    textStatusUnknown: "text-gray-500",
    dashboardDateMuted: "text-gray-400",
    dashboardDateInvalid: "text-red-400",
    dashboardDateToday: "text-[#FDC101]",
    dashboardDateTodayBadge: "rounded-2xl px-2 py-1 font-bold text-sm bg-[#FDC10126] border border-[#FDC10140]",
    dashboardDateTomorrow: "text-[#68D7FF]",
    dashboardDateTomorrowBadge: "rounded-2xl px-2 py-1 font-bold text-sm bg-[#68D7FF26] border border-[#68D7FF40]",
    dashboardDateYesterday: "text-[#FF4D3A]",
    dashboardDateYesterdayBadge: "rounded-2xl px-2 py-1 font-bold text-sm bg-[#FF4D3A26] border border-[#FF4D3A40]",
    dashboardDateFuture: "text-[#FFFFFF]",
    textDanger: "text-[#FF5050]",
    textWarning: "text-[#FF9501]",
    textStatusSuccess: "text-[#00B649]",
    textDisabled: "text-gray-500",
    textDisabledControl: "text-gray-400",
    textDisabledAction: "text-gray-400",
    textCharacterCount: "text-gray-500",
    textDangerLight: "text-red-400",
    hoverTextDangerLight: "hover:text-red-400",
    textRequired: "text-red-500",
    textAccentCyan: "text-[#01BBFE]",
    hoverTextAccentCyan: "hover:text-blue-400",
    textNeutralLight: "text-gray-200",
    textNeutralMuted: "text-gray-400",
    hoverTextNeutral: "hover:text-gray-600",
    textSuccessBright: "text-green-500",
    bgSuccessBright: "bg-green-500",
    textFailureBright: "text-red-500",
    textDangerSubtle: "text-red-400",
    hoverTextDanger: "hover:text-red-500",
    textStaticWhite: "text-white",
    textConflictUndefined: "text-gray-900",
    bgConflictUndefined: "bg-white",
    bgSuccessSubtle: "bg-green-900/30",
    borderSuccessSubtle: "border-green-500/30",
    bgFailureSubtle: "bg-red-900/30",
    borderFailureSubtle: "border-red-500/30",
    borderDangerSubtle: "border-red-400",
    bgSuccessLight: "bg-green-100",
    textSuccessDark: "text-green-800",
    bgFailureLight: "bg-red-100",
    textFailureDark: "text-red-800",
    importStatusCreated: "text-[#2FFF83] bg-[#00B6491A]",
    importStatusRejected: "text-[#A7A7A7] bg-[#D9D9D91A]",
    importStatusFailed: "text-[#FF4D3A] bg-[#FF4D3A26]",
    importStatusInProgress: "text-[#FF8400] bg-[#FF84001A]",
    buttonComparisonSelect: "bg-gradient-to-r from-blue-400 to-blue-600 hover:from-blue-500 hover:to-blue-700",
    textComparisonPrimary: "text-gray-200",
    textComparisonMuted: "text-gray-400",
    textComparisonLink: "text-blue-400",
    hoverTextComparisonLink: "hover:text-blue-300",
    iconMuted: "text-gray-400",
    textMessage: "text-[#FFFFFFD9]",
    textNormal: "text-[#FFFFFF]",
    textSuccess: "text-[#00A621]",
    textStatusAnalysis: "text-[#FF4800]",
    textStatusRequest: "text-[#CD00D0]",
    textStatusVerification: "text-[#FF9501]",
    textStatusReview: "text-[#14EFFF]",
    textStatusFollowup: "text-[#3999FF]",
    textStatusReverification: "text-[#B2DC3F]",
    textStatusActiveStep: "text-[#68D7FF]",
    textStatusTagPending: "text-orange-300",
    textStatusTagDone: "text-green-300",
    textStatusTagCompletion: "text-yellow-300",
    textStatusAllowed: "text-[#00B649]",
    textStatusBlocked: "text-[#FF5050]",
    textSelectAllInactive: "text-[#4D5460]",
    iconOnPrimary: "text-gray-800",
    textOnPrimary: "text-white",
    textStatusCompleted: "text-green-500",
    textStatusRejected: "text-red-500",
    textStatusDefault: "text-gray-500",
    iconAttachment: "text-gray-300",

    // Borders
    borderPrimary: "border-[#414956]",
    borderOnPrimary: "border-white",
    borderActiveDashed: "border-[#19C2FF7D]",
    borderLoader: "border-blue-500",
    borderHoverPrimary: "hover:border-[#19C2FF7D]",
    divider: "border-gray-600",
    dividerDashed: "border-[#191B1F]",
    borderOutLineButton: "border-[#01BBFE]",
    borderPaginationButton: "border-[#3E444E]",
    borderDangerOutLineButton: "border-[#FF5050]",
    borderDisabledOutLineButton: "border-gray-500",
    borderRadio: "border-[#3A4047]",
    borderSelectedOption: "border-[#01BBFE]",
    borderDialogInactive: "border-gray-700",
    borderMuted: "border-gray-600",
    borderDisabled: "border-gray-400",
    borderTimeline: "border-gray-400",
    borderPolicyAttribute: "border-[#4A4F57]",
    borderSection: "border-[#3F4B57]",
    borderColorSwatch: "border-gray-300",
    borderColorSwatchSelected: "border-gray-800",
    borderDashedMuted: "border-gray-400",
    hoverBorderDashedMuted: "hover:border-gray-300",
    borderRadioChecked: "checked:border-[#00C2FF]",
    bgRadioChecked: "after:bg-[#00C2FF] checked:after:bg-[#00C2FF]",

    // Interactive elements
    hover: "hover:bg-gray-700",
    hoverTableRow: "hover:bg-[#01BBFE0F]",
    hoverTextDanger: "hover:text-red-400",
    hoverTextDangerStrong: "hover:text-red-400",
    hoverTextComparisonLinkStrong: "hover:text-blue-400",
    hoverTextPrimary: "hover:text-white",
    active: "bg-gray-700",
    hoverTextSecondary: "hover:text-gray-300",
    hoverBgSelectedRow: "hover:bg-gray-700",
    focusBorder: "focus:border-[#01BBFE]",
    focusRing: "focus:ring-1 focus:ring-[#01BBFE]",
    focusRing2: "focus:ring-2 focus:ring-[#01BBFE]",
    focusRingPrimary: "focus:ring-blue-500",
    focusRingPrimarySoft: "focus:ring-[#01BBFE33]",
    focusRingDanger: "focus:ring-red-500",
    focusRingWarning: "focus:ring-yellow-500",
    controlThumb: "after:bg-white peer-checked:after:border-white",
    hoverBgSelectedItem: "hover:bg-[#01BBFE29]",
    hoverOutlineModalSelection: "hover:bg-blue-900/20",
    bgTooltip: "!bg-gray-100",
    textTooltip: "!text-gray-900",
    buttonVerificationRequest: "bg-gradient-to-r from-[#1EC6FF] to-[#367FFF] hover:bg-gradient-to-l hover:from-[#1EC6FF] hover:to-[#367FFF]",
    buttonSearchHover: "hover:bg-blue-700",
    statusBadgeAnalyzing: "bg-orange-100 text-orange-700 border-orange-200",
    statusBadgeReview: "bg-blue-100 text-blue-700 border-blue-200",
    statusBadgeReady: "bg-green-100 text-green-700 border-green-200",
    statusBadgeFabricating: "bg-purple-100 text-purple-700 border-purple-200",
    statusBadgeWarning: "bg-yellow-100 text-yellow-700 border-yellow-200",
    statusBadgeDefault: "border-gray-200 bg-gray-100 text-gray-700",
    // Badge component variants
    badgeVariantDefault: "bg-gray-700 text-gray-200",
    badgeVariantPrimary: "bg-blue-900 text-blue-200",
    badgeVariantSecondary: "bg-gray-700 text-gray-200",
    badgeVariantSuccess: "bg-green-900 text-green-200",
    badgeVariantWarning: "bg-yellow-900 text-yellow-200",
    badgeVariantDanger: "bg-red-900 text-red-200",
    badgeVariantInfo: "bg-blue-900 text-blue-200",
    badgeVariantConflict: "bg-red-600 text-white",
    badgeVariantObligation1: "bg-black text-white",
    badgeVariantObligation2: "bg-red-600 text-white",
    badgeVariantObligation5: "bg-green-600 text-white",
    badgeVariantVulnText: "text-white",
    badgeVariantVulnCritical: "bg-red-600 text-white",
    badgeVariantVulnHigh: "bg-red-600 text-white",
    badgeVariantVulnMedium: "bg-orange-600 text-white",
    filterChipRequestActive: "bg-[#FF4D3A] text-white border-[#FF4D3A]",
    filterChipAnalysisActive: "bg-[#E25C27] text-white border-[#E25C27]",
    filterChipUsageActive: "bg-[#FFAF01] text-gray-900 border-[#FFAF01]",
    filterChipVerificationActive: "bg-[#42C83C] text-white border-[#42C83C]",
    filterChipFulfillmentActive: "bg-[#01BBFE] text-white border-[#01BBFE]",
    communicationTagRequest: "bg-[#FF4D3A26] text-[#FF4D3A] border-[#FF4D3A]",
    communicationTagVerification: "bg-[#42C83C1C] text-[#42C83C] border-[#42C83C]",
    communicationTagAnalysis: "bg-[#FF4800]/10 text-[#E25C27] border-[#E25C27]",
    communicationTagUsage: "bg-[#FFAF011C] text-[#FFAF01] border-[#FFAF01]",
    communicationTagUsageSubtleBorder: "bg-[#FFAF011C] text-[#FFAF01] border-[#FFAF013B]",
    communicationTagReview: "bg-indigo-500 text-white border-indigo-500",
    communicationTagFollowUp: "bg-orange-500 text-white border-orange-500",
    communicationTagFulfillment: "bg-[#01BBFE26] text-[#68D7FF] border-[#01BBFE99]",
    communicationTagReady: "bg-emerald-500 text-white border-emerald-500",
    communicationTagDefault: "bg-gray-400 text-white border-gray-500",
    communicationFilterRequest: "text-[#FF4D3A] border-[#FF4D3A]",
    communicationFilterAnalysis: "text-[#E25C27] border-[#E25C27]",
    communicationFilterUsage: "text-[#FFAF01] border-[#FFAF01]",
    communicationFilterUsageSubtleBorder: "text-[#FFAF01] border-[#FFAF013B]",
    communicationFilterVerification: "text-[#42C83C] border-[#42C83C]",
    communicationFilterFulfillment: "text-[#68D7FF] border-[#01BBFE99]",
    bgTimeline: "bg-gray-400",
    statusExampleActive: "bg-green-900 text-green-200",
    statusExampleInactive: "bg-red-900 text-red-200",
    buttonExamplePrimary: "bg-blue-600 text-white hover:bg-blue-700",
    bgExampleSelected: "bg-blue-900/20",
    textExampleSelectedTitle: "text-blue-100",
    textExampleSelected: "text-blue-300",

    // Sidebar specific
    sidebarBackground: "bg-[#282D32]",
    sidebarText: "text-gray-300",
    sidebarHover: "hover:bg-gray-800",
    sidebarActive: "bg-gray-800 text-blue-400",
    sidebarMenuLabel: "text-[#9EA5B3]",
    sidebarIconInactive: "text-[#9CA3AF]",
    sidebarIconActive: "text-[#01BBFE]",
    sidebarTextInactive: "text-[#9EA5B3]",
    sidebarTextActive: "text-[#01BBFE]",
    sidebarHoverBg: "hover:bg-[#374151]",
    sidebarHoverText: "hover:text-[#E5E7EB]",
    sidebarSubmenuActiveBg: "bg-[#01BBFE26]",
    sidebarSubmenuActiveText: "text-[#01BBFE]",
    sidebarSubmenuActiveBorder: "bg-[#01BBFE]",
    sidebarSubmenuVerticalLine: "bg-[#01BBFE4D]",
    sidebarToggleBg: "bg-[#191B1F]",
    sidebarToggleBorder: "border-[#4B5563]",
    sidebarToggleActiveBg: "bg-[#4B5563]",
    sidebarToggleActiveText: "text-white",
    sidebarToggleInactiveText: "text-[#9CA3AF]",
    sidebarToggleHoverText: "hover:text-[#E5E7EB]",
    sidebarToggleLightButtonText: "text-[#1F2937]",
    sidebarToggleLightButtonBg: "bg-white",
    sidebarTextPrimary: "text-white",
    sidebarHoverTextPrimary: "hover:text-white",
    sidebarCopyright: "text-[#797D87]",
    sidebarTooltipBg: "#1f2937",
    sidebarTooltipText: "#ffffff",

    // Header specific
    headerBackground: "bg-[#282D32]",
    headerBorder: "border-[#2A2D35]",
    headerText: "text-white",
    headerDivider: "bg-[#4B5563]",
    headerDividerBorder: "border-[#4B5563]",
    headerHover: "hover:bg-[#374151]",
    headerMuted: "text-[#9CA3AF]",
    headerMenuText: "text-[#E5E7EB]",
    headerIcon: "text-gray-400",
    headerDangerText: "text-red-400",
    headerDangerHover: "hover:bg-red-900/20",
    headerDangerHoverText: "group-hover:text-red-300",
    headerTooltipBackgroundColor: "#f3f4f6",
    headerTooltipTextColor: "#111827",

    // Hover
    hoverTextPrimary: "hover:text-[#FFFFFFFF]",
    hoverCheckbox: "hover:border-[#19C2FF7D]",
    hoverBorderDashed: "hover:border-[#191B1F]",
    hoverBorderDashedActive: "hover:border-[#01BBFE]",

    // Icon
    iconDelete: "text-red-500",

    // Custom colors
    bgInputColor: "#00000033",
    borderPrimaryColor: "#414956",
    textPrimaryColor: "#FFFFFFD9",
    textSecondaryColor: "#A6ACBE",
    chartTextColor: "#FFFFFFD9",
    chartTooltipBackgroundColor: "#374151",
    chartTooltipTextColor: "#FFFFFF",
    chartLabelBackgroundColor: "#FFFFFFB2",
    chartLabelBorderColor: "#FFFFFF",
    chartSeriesPurple: "#7252FF",
    chartSeriesLime: "#CBFB47",
    chartSeriesPink: "#EF7BE3",
    chartSeriesYellow: "#FFC300",
    chartSeriesCyan: "#4CC9F0",
    chartSeriesOrange: "#F59E0B",
    chartSeriesRed: "#EF4444",
    chartSeriesMagenta: "#EC4899",
    chartSeriesBlue: "#3B82F6",
    chartSeriesGreen: "#10B981",
    chartSeriesBlack: "#000000",
    chartSeriesRedSubtle: "rgba(239, 68, 68, 0.1)",
    chartLegendColor: "#E5E7EB",
    chartGridColor: "#374151",
    chartTickColor: "#E5E7EB",
    chartCrosshairColor: "#6B7280",
    chartTooltipBg: "#1E293B",
    chartTooltipTitle: "#F8FAFC",
    chartTooltipBody: "#E2E8F0",
    chartTooltipBorder: "#475569",
    chartDonutHoleBg: "#282D32",
    chartRingTrackBg: "#FFFFFF0D",
    textPlaceholderColor: "#646874",
    textActiveColor: "#01BBFE",
    borderActiveColor: "#19C2FF7D",
    bgPrimaryColor: "#292D33",
    dropdownSelectedColor: "#00000099",
    dropdownBorderColor: "#FFFFFF0D",
    bgUncheckedCheckboxColor: "#414956",
    badgeTextColor: "#191B1F",
    chipBg: "#3E444E",
    chipRemove: "#FFFFFFD9",
    chipRemoveHoverBg: "#FFFFFFD9",
    chipRemoveHoverText: "#3E444E",
    chartTooltipBackground: "#374151",
    chartTooltipText: "#FFFFFF",
    chartLabelBadgeBackground: "#FFFFFFB2",
    chartLabelBadgeBorder: "#FFFFFF",
    emptyColorDatePicker: "#9CA3AF",
    colorDatePicker: "#FFFFFFE5",
    // Functions for select placeholder color
    getSelectColor: (isEmpty) => (isEmpty ? "#646874" : "#FFFFFFE5"),
  },
  dark: {
    // Main backgrounds
    bgPrimary: "bg-[#292D33]",
    bgSecondary: "bg-[#191B1F]",
    bgTertiary: "bg-[#23262B]",
    bgPrimaryDarker: "bg-[#32363D]",
    bgCard: "bg-gray-800",
    cardBackground: "bg-[#292D33]",
    bgDropFiles: "bg-[#002F4036]",
    bgDropFilesActive: "bg-blue-900/20",
    bgInput: "bg-[#00000033]",
    bgBlurModal: "bg-[#000000]/60",
    bgNoTag: "bg-[#FFFFFF]/80",
    bgActiveToggle: "bg-[#2D8F00]",
    bgModal: "bg-[#24292D]",
    bgSelectedRow: "bg-[#234455]",
    bgSelectedItem: "bg-[#01BBFE29]",
    bgSelectedOption: "bg-[#01BBFE1A]",
    bgSelectedRadio: "bg-[#01BBFE]",
    bgSelectedCyanSubtle: "bg-cyan-500/10",
    bgImportOverlay: "bg-black/70",
    bgSkeleton: "bg-gray-600",
    bgSkeletonDark: "bg-gray-600",
    bgTableBody: "bg-[#2A2D34]",
    bgTableHeader: "bg-[#292D33]",
    bgTableStripe: "bg-[#23262B]",
    bgRadioInactive: "bg-[#191B1F]",
    bgRadioSelected: "bg-[#333131]",
    bgDisabledControl: "bg-gray-800",
    bgEditedRow: "bg-green-900/20",
    bgMoveDisabled: "bg-gray-400",
    bgDisabledAction: "bg-gray-600",
    buttonMoveGradient: "bg-gradient-to-br from-blue-400 to-blue-600",
    buttonMoveGradientHover: "hover:from-blue-500 hover:to-blue-700",
    bgPaginationButtonActive: "bg-[#3F454D]",
    bgActivePrimary: "bg-[#01BBFE]",
    bgButton: "bg-transparent",
    bgDocumentTable: "bg-[#B0C1D90F]",
    bgFulfillmentStripe: "bg-[#23262B]",
    bgSelectedPreviewName: "bg-[#32363D]",
    bgPolicyConflict: "bg-[#9EA5B3]",
    bgVerifReportFile: "bg-[#23262B]",
    bgBasicInfo: "bg-[#212429]",
    bgDanger: "bg-[#FF5050]",
    bgAddVerificationFileBtn: "bg-[#202d36]",
    bgActiveTab: "bg-[#01BBFE26]",
    bgCommunicationDetail: "bg-[#32363D]",
    bgDivider: "bg-[#414956]",
    bgCompletionRequestDate: "bg-[#FDC1010F]",
    bgCommunicationFilterButtonActive: "bg-[#6C727B]",
    bgCommunicationFilterButton: "bg-[#3E444E]",
    bgStatusHealthy: "bg-green-500",
    bgStatusUnhealthy: "bg-red-500",
    bgStatusUnconfigured: "bg-yellow-500",
    bgStatusUnknown: "bg-gray-500",
    dashboardMetricCard: "bg-gradient-to-b from-[#01BBFE26] to-transparent border-[#01BBFE36]",
    dashboardMetricCardDanger: "bg-gradient-to-b from-[rgba(254,31,1,0.15)] to-transparent border-[#FC3F3F36]",
    dashboardChartRingBg: "bg-[#FFFFFF0D]",
    dashboardLegendPurple: "bg-[#7252FF]",
    dashboardLegendPink: "bg-[#EF7BE3]",
    dashboardLegendLime: "bg-[#CBFB47]",
    dashboardUsageToggleBg: "bg-[#191B1F]",
    dashboardUsageToggleActive: "bg-[#343B43] text-white font-semibold",
    dashboardUsageToggleInactive: "text-gray-400 bg-[#191B1F]",
    dashboardPanelBg: "bg-[#282D32]",
    dashboardProgressTrack: "bg-gray-700",
    dashboardProgressJvm: "bg-blue-500",
    dashboardProgressMemory: "bg-green-500",
    dashboardProgressCpu: "bg-yellow-500",
    dashboardProgressDisk: "bg-purple-500",
    bgDisableButton: "bg-[#CA2C26]",
    bgPolicyStepItemLeftSide: "bg-[#191B1F80]",
    bgPolicyStepItem: "bg-[#23262B]",
    bgPolicyAttributeItemLeftSide: "bg-[#5B6D8C8F]",
    bgPolicyAttributeItemRightSide: "bg-[#7DACC921]",
    bgToggleSwitchActive: "bg-[#2D8F00]",
    bgToggleSwitchInactive: "bg-gray-600",
    toggleThumbBackground: "bg-white",
    bgButtonDanger: "bg-[#CA2C26]",
    bgButtonDangerHover: "hover:bg-red-700",
    bgWarning: "bg-yellow-600",
    bgWarningHover: "hover:bg-yellow-700",
    bgStatusWarning: "bg-[#FF9501]",
    bgStatusSuccess: "bg-[#00B649]",
    bgStatusMuted: "bg-gray-400",
    bgStatusAnalysis: "bg-[#FF4800]",
    bgStatusRequest: "bg-[#CD00D0]",
    bgStatusVerification: "bg-[#FF9501]",
    bgStatusReview: "bg-[#14EFFF]",
    bgStatusFollowup: "bg-[#3999FF]",
    bgStatusReverification: "bg-[#B2DC3F]",
    bgStatusWritingReview: "bg-[#00BDEC]",
    bgStatusTagPending: "bg-orange-900/30",
    bgStatusTagDone: "bg-green-900/30",
    bgStatusTagCompletion: "bg-yellow-900/30",
    bgStatusTagNeutral: "bg-gray-700",
    bgStatusAllowed: "bg-[#00B6491A]",
    bgStatusBlocked: "bg-[#FF50501A]",
    textStatusAllowedBright: "text-[#2FFF83]",
    textDangerSoft: "text-[#FF9A9A]",
    textStatusWritingReview: "text-[#00BDEC]",
    requestStatusPendingCompletion: "text-[#FF8400] bg-[#FF840029]",
    requestStatusPendingApproval: "text-[#68D7FF] bg-[#68D7FF29]",
    requestStatusDone: "text-[#2FFF83] bg-[#00B64929]",
    alertUploadWarning: "border-yellow-200 bg-yellow-50 text-yellow-800",
    buttonDangerOutlineActive: "bg-transparent border-[#FF5050] text-[#FF5050]",
    hoverBgDangerSoft: "hover:bg-red-500/20",
    bgVulnMatrixPanel: "bg-[#191B1F]",
    bgVulnMatrixCellEmpty: "bg-[#212327]",
    borderVulnMatrix: "border-[#2b2d31]",
    textVulnMatrixLabel: "text-gray-300",
    policyItemChip: "bg-[#414956] text-white",
    matrixCellDisabled: "opacity-50 cursor-not-allowed bg-gray-600 text-gray-400",
    matrixCellActive: "text-white hover:opacity-80",
    hoverTextNeutralStrong: "hover:text-gray-200",
    importStatusIdle: "text-[#9CA3AF] bg-[#9CA3AF29]",
    bgMailTypeExternal: "bg-[#FDC1011A]",
    badgeYes: "bg-[#C3FF61] text-gray-800",
    badgeNo: "bg-gray-500 text-gray-200",
    bgGroupCardActive: "bg-blue-500/30",
    buttonDisabledMuted: "cursor-not-allowed bg-gray-400 text-gray-600 opacity-50",
    badgeRoleChip: "bg-gray-700 text-gray-300",
    bgSbomInfoPanel: "bg-[#2b2f38]",
    textInfoAccent: "text-sky-500",
    hoverTextInfoAccent: "hover:text-sky-400",
    licensePeriodSummaryBorder: "border-[#01BBFE66]",
    licensePeriodSummaryChip: "border border-[#01BBFE80] bg-[#01BBFE26] text-[#01BBFE]",
    licensePeriodCurrentBadge: "bg-[#01BBFE] text-white",
    licensePeriodCurrentAccent: "border-l-2 border-[#01BBFE]",
    licensePeriodRankLow: "border border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
    licensePeriodRankMedium: "border border-orange-500/40 text-orange-400 bg-orange-500/10",
    licensePeriodRankHigh: "border border-red-500/40 text-red-400 bg-red-500/10",
    licensePeriodRankCritical: "border border-rose-500/50 text-rose-300 bg-rose-500/15",
    licensePeriodConfidenceConfirmed: "border border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
    licensePeriodConfidenceLikely: "border border-orange-500/40 text-orange-400 bg-orange-500/10",
    licensePeriodConfidencePossible: "border border-yellow-500/40 text-yellow-400 bg-yellow-500/10",
    licensePeriodConfidenceDefault: "border border-gray-500/40 text-gray-300 bg-gray-500/10",
    textLicensePeriodAccent: "text-[#01BBFE]",
    bgAvatarNeutral: "bg-gray-500",
    bgAvatarBlue: "bg-blue-500",
    bgAvatarGreen: "bg-green-500",
    bgAvatarPurple: "bg-purple-500",
    bgAvatarPink: "bg-pink-500",
    bgAvatarIndigo: "bg-indigo-500",
    bgAvatarYellow: "bg-yellow-500",
    bgAvatarRed: "bg-red-500",
    bgAvatarTeal: "bg-teal-500",
    bgActionPrimary: "bg-blue-500",
    hoverActionPrimary: "hover:bg-blue-600",
    dividerColor: "bg-[#414956]",

    // Buttons
    buttonBackgroundGradient: "bg-gradient-to-r from-[#1EC6FF] to-[#367FFF]",
    buttonBackgroundPurple: "bg-gradient-to-r from-[#C374FF] to-[#C084FF]",
    buttonBackgroundPurpleHover: "hover:bg-gradient-to-l hover:from-[#C374FF] hover:to-[#C084FF]",
    buttonBackgroundGradientHover: "hover:bg-gradient-to-l hover:from-[#1EC6FF] hover:to-[#367FFF]",
    buttonDangerBackground: "bg-[#CA2C26]",
    buttonDangerBackgroundHover: "hover:bg-red-600",
    buttonSuccess: "bg-green-600 text-white hover:bg-green-700",
    alertInfo: "bg-blue-900/20 border-blue-500/30 text-blue-200",
    alertSuccess: "bg-green-900/20 border-green-500/30 text-green-200",
    alertWarning: "bg-amber-500/10 border-amber-500/40",
    alertError: "bg-red-900/20 border-red-500/30 text-red-200",
    alertErrorSoft: "bg-red-500/10 border-red-500/40",
    bgIconAccent: "bg-[#01BBFE33]",
    spinnerBorder: "border-[#414956] border-t-[#01BBFE]",
    // Text colors
    textPrimary: "text-[#FFFFFFE5]",
    textSecondary: "text-[#A6ACBE]",
    textModalMessage: "text-[#A6ACBE]",
    textSubTitle: "text-[#9EA5B3]",
    textActive: "text-[#01BBFE]",
    textHoverActive: "hover:text-[#01BBFE]",
    textMuted: "text-gray-400",
    textPlaceholder: "placeholder-[#646874]",
    textButton: "text-[#000000]",
    hoverTextButton: "hover:text-black",
    textCompletionRequestDate: "text-[#FDC101]",
    textStatusHealthy: "text-green-500",
    textStatusUnhealthy: "text-red-500",
    textStatusUnconfigured: "text-yellow-500",
    textStatusUnknown: "text-gray-500",
    dashboardDateMuted: "text-gray-400",
    dashboardDateInvalid: "text-red-400",
    dashboardDateToday: "text-[#FDC101]",
    dashboardDateTodayBadge: "rounded-2xl px-2 py-1 font-bold text-sm bg-[#FDC10126] border border-[#FDC10140]",
    dashboardDateTomorrow: "text-[#68D7FF]",
    dashboardDateTomorrowBadge: "rounded-2xl px-2 py-1 font-bold text-sm bg-[#68D7FF26] border border-[#68D7FF40]",
    dashboardDateYesterday: "text-[#FF4D3A]",
    dashboardDateYesterdayBadge: "rounded-2xl px-2 py-1 font-bold text-sm bg-[#FF4D3A26] border border-[#FF4D3A40]",
    dashboardDateFuture: "text-[#FFFFFF]",
    textDanger: "text-[#FF5050]",
    textWarning: "text-[#FF9501]",
    textStatusSuccess: "text-[#00B649]",
    textDisabled: "text-gray-500",
    textDisabledControl: "text-gray-400",
    textDisabledAction: "text-gray-400",
    textCharacterCount: "text-gray-500",
    textDangerLight: "text-red-400",
    hoverTextDangerLight: "hover:text-red-400",
    textRequired: "text-red-500",
    textAccentCyan: "text-[#01BBFE]",
    hoverTextAccentCyan: "hover:text-blue-400",
    textNeutralLight: "text-gray-200",
    textNeutralMuted: "text-gray-400",
    hoverTextNeutral: "hover:text-gray-600",
    textSuccessBright: "text-green-500",
    bgSuccessBright: "bg-green-500",
    textFailureBright: "text-red-500",
    textDangerSubtle: "text-red-400",
    hoverTextDanger: "hover:text-red-500",
    textStaticWhite: "text-white",
    textConflictUndefined: "text-gray-900",
    bgConflictUndefined: "bg-white",
    bgSuccessSubtle: "bg-green-900/30",
    borderSuccessSubtle: "border-green-500/30",
    bgFailureSubtle: "bg-red-900/30",
    borderFailureSubtle: "border-red-500/30",
    borderDangerSubtle: "border-red-400",
    bgSuccessLight: "bg-green-100",
    textSuccessDark: "text-green-800",
    bgFailureLight: "bg-red-100",
    textFailureDark: "text-red-800",
    importStatusCreated: "text-[#2FFF83] bg-[#00B6491A]",
    importStatusRejected: "text-[#A7A7A7] bg-[#D9D9D91A]",
    importStatusFailed: "text-[#FF4D3A] bg-[#FF4D3A26]",
    importStatusInProgress: "text-[#FF8400] bg-[#FF84001A]",
    buttonComparisonSelect: "bg-gradient-to-r from-blue-400 to-blue-600 hover:from-blue-500 hover:to-blue-700",
    textComparisonPrimary: "text-gray-200",
    textComparisonMuted: "text-gray-400",
    textComparisonLink: "text-blue-400",
    hoverTextComparisonLink: "hover:text-blue-300",
    iconMuted: "text-gray-400",
    textMessage: "text-[#FFFFFFD9]",
    textNormal: "text-[#FFFFFF]",
    textSuccess: "text-[#00A621]",
    textStatusAnalysis: "text-[#FF4800]",
    textStatusRequest: "text-[#CD00D0]",
    textStatusVerification: "text-[#FF9501]",
    textStatusReview: "text-[#14EFFF]",
    textStatusFollowup: "text-[#3999FF]",
    textStatusReverification: "text-[#B2DC3F]",
    textStatusActiveStep: "text-[#68D7FF]",
    textStatusTagPending: "text-orange-300",
    textStatusTagDone: "text-green-300",
    textStatusTagCompletion: "text-yellow-300",
    textStatusAllowed: "text-[#00B649]",
    textStatusBlocked: "text-[#FF5050]",
    textSelectAllInactive: "text-[#4D5460]",
    iconOnPrimary: "text-gray-800",
    textOnPrimary: "text-white",
    textStatusCompleted: "text-green-500",
    textStatusRejected: "text-red-500",
    textStatusDefault: "text-gray-500",
    iconAttachment: "text-gray-300",

    // Borders
    borderPrimary: "border-[#414956]",
    borderOnPrimary: "border-white",
    borderActiveDashed: "border-[#19C2FF7D]",
    borderLoader: "border-blue-500",
    borderHoverPrimary: "hover:border-[#19C2FF7D]",
    divider: "border-gray-600",
    dividerDashed: "border-[#191B1F]",
    borderOutLineButton: "border-[#01BBFE]",
    borderPaginationButton: "border-[#3E444E]",
    borderDangerOutLineButton: "border-[#FF5050]",
    borderDisabledOutLineButton: "border-gray-500",
    borderRadio: "border-[#3A4047]",
    borderSelectedOption: "border-[#01BBFE]",
    borderDialogInactive: "border-gray-700",
    borderMuted: "border-gray-600",
    borderDisabled: "border-gray-400",
    borderTimeline: "border-gray-400",
    borderPolicyAttribute: "border-[#4A4F57]",
    borderSection: "border-[#3F4B57]",
    borderColorSwatch: "border-gray-300",
    borderColorSwatchSelected: "border-gray-800",
    borderDashedMuted: "border-gray-400",
    hoverBorderDashedMuted: "hover:border-gray-300",
    borderRadioChecked: "checked:border-[#00C2FF]",
    bgRadioChecked: "after:bg-[#00C2FF] checked:after:bg-[#00C2FF]",

    // Interactive elements
    hover: "hover:bg-gray-700",
    hoverTableRow: "hover:bg-[#01BBFE0F]",
    hoverTextDanger: "hover:text-red-400",
    hoverTextDangerStrong: "hover:text-red-400",
    hoverTextComparisonLinkStrong: "hover:text-blue-400",
    hoverTextPrimary: "hover:text-white",
    active: "bg-gray-700",
    hoverTextSecondary: "hover:text-gray-300",
    hoverBgSelectedRow: "hover:bg-gray-700",
    focusBorder: "focus:border-[#01BBFE]",
    focusRing: "focus:ring-1 focus:ring-[#01BBFE]",
    focusRing2: "focus:ring-2 focus:ring-[#01BBFE]",
    focusRingPrimary: "focus:ring-blue-500",
    focusRingPrimarySoft: "focus:ring-[#01BBFE33]",
    focusRingDanger: "focus:ring-red-500",
    focusRingWarning: "focus:ring-yellow-500",
    controlThumb: "after:bg-white peer-checked:after:border-white",
    hoverBgSelectedItem: "hover:bg-[#01BBFE29]",
    hoverOutlineModalSelection: "hover:bg-blue-900/20",
    bgTooltip: "!bg-gray-100",
    textTooltip: "!text-gray-900",
    buttonVerificationRequest: "bg-gradient-to-r from-[#1EC6FF] to-[#367FFF] hover:bg-gradient-to-l hover:from-[#1EC6FF] hover:to-[#367FFF]",
    buttonSearchHover: "hover:bg-blue-700",
    statusBadgeAnalyzing: "bg-orange-100 text-orange-700 border-orange-200",
    statusBadgeReview: "bg-blue-100 text-blue-700 border-blue-200",
    statusBadgeReady: "bg-green-100 text-green-700 border-green-200",
    statusBadgeFabricating: "bg-purple-100 text-purple-700 border-purple-200",
    statusBadgeWarning: "bg-yellow-100 text-yellow-700 border-yellow-200",
    statusBadgeDefault: "border-gray-200 bg-gray-100 text-gray-700",
    // Badge component variants
    badgeVariantDefault: "bg-gray-700 text-gray-200",
    badgeVariantPrimary: "bg-blue-900 text-blue-200",
    badgeVariantSecondary: "bg-gray-700 text-gray-200",
    badgeVariantSuccess: "bg-green-900 text-green-200",
    badgeVariantWarning: "bg-yellow-900 text-yellow-200",
    badgeVariantDanger: "bg-red-900 text-red-200",
    badgeVariantInfo: "bg-blue-900 text-blue-200",
    badgeVariantConflict: "bg-red-600 text-white",
    badgeVariantObligation1: "bg-black text-white",
    badgeVariantObligation2: "bg-red-600 text-white",
    badgeVariantObligation5: "bg-green-600 text-white",
    badgeVariantVulnText: "text-white",
    badgeVariantVulnCritical: "bg-red-600 text-white",
    badgeVariantVulnHigh: "bg-red-600 text-white",
    badgeVariantVulnMedium: "bg-orange-600 text-white",
    filterChipRequestActive: "bg-[#FF4D3A] text-white border-[#FF4D3A]",
    filterChipAnalysisActive: "bg-[#E25C27] text-white border-[#E25C27]",
    filterChipUsageActive: "bg-[#FFAF01] text-gray-900 border-[#FFAF01]",
    filterChipVerificationActive: "bg-[#42C83C] text-white border-[#42C83C]",
    filterChipFulfillmentActive: "bg-[#01BBFE] text-white border-[#01BBFE]",
    communicationTagRequest: "bg-[#FF4D3A26] text-[#FF4D3A] border-[#FF4D3A]",
    communicationTagVerification: "bg-[#42C83C1C] text-[#42C83C] border-[#42C83C]",
    communicationTagAnalysis: "bg-[#FF4800]/10 text-[#E25C27] border-[#E25C27]",
    communicationTagUsage: "bg-[#FFAF011C] text-[#FFAF01] border-[#FFAF01]",
    communicationTagUsageSubtleBorder: "bg-[#FFAF011C] text-[#FFAF01] border-[#FFAF013B]",
    communicationTagReview: "bg-indigo-500 text-white border-indigo-500",
    communicationTagFollowUp: "bg-orange-500 text-white border-orange-500",
    communicationTagFulfillment: "bg-[#01BBFE26] text-[#68D7FF] border-[#01BBFE99]",
    communicationTagReady: "bg-emerald-500 text-white border-emerald-500",
    communicationTagDefault: "bg-gray-400 text-white border-gray-500",
    communicationFilterRequest: "text-[#FF4D3A] border-[#FF4D3A]",
    communicationFilterAnalysis: "text-[#E25C27] border-[#E25C27]",
    communicationFilterUsage: "text-[#FFAF01] border-[#FFAF01]",
    communicationFilterUsageSubtleBorder: "text-[#FFAF01] border-[#FFAF013B]",
    communicationFilterVerification: "text-[#42C83C] border-[#42C83C]",
    communicationFilterFulfillment: "text-[#68D7FF] border-[#01BBFE99]",
    bgTimeline: "bg-gray-400",
    statusExampleActive: "bg-green-900 text-green-200",
    statusExampleInactive: "bg-red-900 text-red-200",
    buttonExamplePrimary: "bg-blue-600 text-white hover:bg-blue-700",
    bgExampleSelected: "bg-blue-900/20",
    textExampleSelectedTitle: "text-blue-100",
    textExampleSelected: "text-blue-300",

    // Sidebar specific
    sidebarBackground: "bg-[#282D32]",
    sidebarText: "text-gray-300",
    sidebarHover: "hover:bg-gray-800",
    sidebarActive: "bg-gray-800 text-blue-400",
    sidebarMenuLabel: "text-[#9EA5B3]",
    sidebarIconInactive: "text-[#9CA3AF]",
    sidebarIconActive: "text-[#01BBFE]",
    sidebarTextInactive: "text-[#9EA5B3]",
    sidebarTextActive: "text-[#01BBFE]",
    sidebarHoverBg: "hover:bg-[#374151]",
    sidebarHoverText: "hover:text-[#E5E7EB]",
    sidebarSubmenuActiveBg: "bg-[#01BBFE26]",
    sidebarSubmenuActiveText: "text-[#01BBFE]",
    sidebarSubmenuActiveBorder: "bg-[#01BBFE]",
    sidebarSubmenuVerticalLine: "bg-[#01BBFE4D]",
    sidebarToggleBg: "bg-[#191B1F]",
    sidebarToggleBorder: "border-[#4B5563]",
    sidebarToggleActiveBg: "bg-[#4B5563]",
    sidebarToggleActiveText: "text-white",
    sidebarToggleInactiveText: "text-[#9CA3AF]",
    sidebarToggleHoverText: "hover:text-[#E5E7EB]",
    sidebarToggleLightButtonText: "text-[#1F2937]",
    sidebarToggleLightButtonBg: "bg-white",
    sidebarTextPrimary: "text-white",
    sidebarHoverTextPrimary: "hover:text-white",
    sidebarCopyright: "text-[#797D87]",
    sidebarTooltipBg: "#1f2937",
    sidebarTooltipText: "#ffffff",

    // Header specific
    headerBackground: "bg-[#282D32]",
    headerBorder: "border-[#2A2D35]",
    headerText: "text-white",
    headerDivider: "bg-[#4B5563]",
    headerDividerBorder: "border-[#4B5563]",
    headerHover: "hover:bg-[#374151]",
    headerMuted: "text-[#9CA3AF]",
    headerMenuText: "text-[#E5E7EB]",
    headerIcon: "text-gray-400",
    headerDangerText: "text-red-400",
    headerDangerHover: "hover:bg-red-900/20",
    headerDangerHoverText: "group-hover:text-red-300",
    headerTooltipBackgroundColor: "#f3f4f6",
    headerTooltipTextColor: "#111827",

    // Hover
    hoverTextPrimary: "hover:text-[#FFFFFFFF]",
    hoverCheckbox: "hover:border-[#19C2FF7D]",
    hoverBorderDashed: "hover:border-[#191B1F]",
    hoverBorderDashedActive: "hover:border-[#01BBFE]",

    // Icon
    iconDelete: "text-red-500",

    // Custom colors
    bgInputColor: "#00000033",
    borderPrimaryColor: "#414956",
    textPrimaryColor: "#FFFFFFD9",
    textSecondaryColor: "#A6ACBE",
    chartTextColor: "#FFFFFFD9",
    chartTooltipBackgroundColor: "#374151",
    chartTooltipTextColor: "#FFFFFF",
    chartLabelBackgroundColor: "#FFFFFFB2",
    chartLabelBorderColor: "#FFFFFF",
    chartSeriesPurple: "#7252FF",
    chartSeriesLime: "#CBFB47",
    chartSeriesPink: "#EF7BE3",
    chartSeriesYellow: "#FFC300",
    chartSeriesCyan: "#4CC9F0",
    chartSeriesOrange: "#F59E0B",
    chartSeriesRed: "#EF4444",
    chartSeriesMagenta: "#EC4899",
    chartSeriesBlue: "#3B82F6",
    chartSeriesGreen: "#10B981",
    chartSeriesBlack: "#000000",
    chartSeriesRedSubtle: "rgba(239, 68, 68, 0.1)",
    chartLegendColor: "#E5E7EB",
    chartGridColor: "#374151",
    chartTickColor: "#E5E7EB",
    chartCrosshairColor: "#6B7280",
    chartTooltipBg: "#1E293B",
    chartTooltipTitle: "#F8FAFC",
    chartTooltipBody: "#E2E8F0",
    chartTooltipBorder: "#475569",
    chartDonutHoleBg: "#282D32",
    chartRingTrackBg: "#FFFFFF0D",
    textPlaceholderColor: "#646874",
    textActiveColor: "#01BBFE",
    borderActiveColor: "#19C2FF7D",
    bgPrimaryColor: "#292D33",
    dropdownSelectedColor: "#00000099",
    dropdownBorderColor: "#FFFFFF0D",
    bgUncheckedCheckboxColor: "#414956",
    badgeTextColor: "#191B1F",
    chipBg: "#3E444E",
    chipRemove: "#FFFFFFD9",
    chipRemoveHoverBg: "#FFFFFFD9",
    chipRemoveHoverText: "#3E444E",
    chartTooltipBackground: "#374151",
    chartTooltipText: "#FFFFFF",
    chartLabelBadgeBackground: "#FFFFFFB2",
    chartLabelBadgeBorder: "#FFFFFF",
    emptyColorDatePicker: "#9CA3AF",
    colorDatePicker: "#FFFFFFE5",
    // Functions for select placeholder color
    getSelectColor: (isEmpty) => (isEmpty ? "#646874" : "#FFFFFFE5"),
  },
};
